module.exports = __webpack_public_path__ + "img/logo.0f172b92.png";